import React from "react";

const NotAuthorized = () => {
  return (
    <div style={{ textAlign: "center", fontSize: "xx-large", color: "red"}}>You do not have permission to access this page</div>
  );
};

export default NotAuthorized;
